<template>
  <div class="extra-row d-flex justify-content-between">
    <div class="extra d-flex justify-content-center align-items-center">
      <label class="radio-label justify-content-center align-items-center">
        <input type="checkbox" v-model="supForm.selected">
        <span class="checkmark"></span>
      </label>
      <div class="name-price">
        <p class="item-subtitle mb-0">{{ extra.name }}</p>
        <small class="text-start mb-0">{{ extra.price == 0 ? '' : extra.price + ' f' }} </small>
      </div>
    </div>
    <div class="stepper" v-if="supForm.selected">
      <Stepper :id="'stepper' + base + extra.id" v-model="supForm.quantity" />
    </div>
  </div>
</template>

<script setup>
import Stepper from "@/components/stepper";
import {ref, watch} from "vue";

// eslint-disable-next-line no-undef
const props = defineProps({
  extra: {
    type: Object,
  },
  disabled: {
    type: Boolean,
    default: false
  },
  base: {
    type: String,
    default: "supp"
  },
  form:{
    type: Object,
    default: () => {
      return {
        selected: false,
        id:'',
        quantity: 0,
        price: 0,
        name: '',
      }
    }
  }
})

const supForm = ref(props.form)

watch(() => props.form, () => {
  supForm.value = props.form
})

watch(() => supForm.value.selected, () => {
  if(supForm.value.selected && supForm.value.quantity == 0){
    supForm.value.quantity = 1
  }
})
</script>

<style scoped>
.item-media img{
  height: 105px;
  min-width: 105px;
  object-fit: cover;
}

.extra .radio-label{
  margin-bottom: 20px;
}

.radio .radio-label input:checked ~ .checkmark{
  background-color: var(--secondary);
  border: 1px solid var(--secondary);
}

.radio.square-radio .radio-label .checkmark{
  border-radius: 5px;
}
.radio.square-radio .radio-label .checkmark:after{
  border-radius: 5px;
}

.company-detail .item-inner li .reviews-info i{
  color: var(--secondary);
}

.radio .radio-label .checkmark:after{
  background: var(--secondary);
}
.extra-row{
  margin-bottom: 12px;
}
.name-price .item-subtitle{
  font-size: 0.75rem;
  font-weight: 600;
}
</style>